import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { ReportCardItem } from "@Components/FollowUp/Report/ReportCardItem"
import { Spacer } from "@Components/Space"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { baseColors } from "@Constants/baseStyles"
import { message } from "@Constants/constant"
import { userAtom } from "@Recoil/Atom/userAtom"
import { ReportService } from "@Services/Report.service"
import { dbDateFormat, localDateFormat } from "@Utils/utils"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { View } from "react-native"
import { ActivityIndicator } from "react-native-paper"
import { useRecoilValue } from "recoil"

export const ReportHome = ({ navigation }) => {
    const [loading, setLoading] = useState(false)
    const user = useRecoilValue(userAtom)
    const [reports, setReports] = useState([])

    const fetchReports = () => {
        setLoading(true)
        ReportService.getAll(user.id)
            .then((response) => {
                const data = response.data?.data
                if (data) {
                    setReports(data)
                }
                setLoading(false)
            })
            .catch((e) => {
                ShowToast({ type: "error", message: message.serverError })
                setLoading(false)
            })
    }

    useEffect(() => {
        fetchReports()
    }, [])

    const empty = reports?.length === 0

    return (
        <ContainerStackScreen>
            <CustomScrollview contentContainerStyle={{ paddingBottom: 100 }} showsVerticalScrollIndicator={false}>
                <BreeSerifText color={baseColors.green.primary} fontSize={24}>
                    Mes compte-rendus
                </BreeSerifText>
                <Spacer height={15} />
                <OpenSansText fontSize={14}>
                    Retrouvez tous les compte-rendus de votre parcours dans les programmes d'éducation thérapeutique de
                    l'application
                </OpenSansText>
                <Spacer height={25} />
                {loading ? (
                    <ActivityIndicator color={baseColors.green.primary} size={"large"} style={{ padding: 30 }} />
                ) : empty ? (
                    <View style={{ flex: 1, alignItems: "center", justifyContent: "center", marginTop: 150 }}>
                        <OpenSansText fontSize={20}>Aucune donnée disponible</OpenSansText>
                    </View>
                ) : (
                    reports?.map((item, i) => (
                        <ReportCardItem
                            onPress={() => navigation.navigate("ReportDetails", { report: item })}
                            date={moment(item.createdAt, dbDateFormat + " HH:mm").format(localDateFormat + " HH:mm")}
                            key={i}
                            title={item.name}
                        />
                    ))
                )}
                <Spacer height={15} />
            </CustomScrollview>
        </ContainerStackScreen>
    )
}
